module.exports = __webpack_public_path__ + "static/Mobile_1@2x-bc071668170473fe85c16d56a32f8697.png";